import React from 'react'
import { UseFormReturn } from 'react-hook-form'

import { FormError, TFormErrorProps } from 'elements/input/FormError'

export type TFormRootErrorProps<FormData extends Record<string, any>> = TFormErrorProps & {
  form: UseFormReturn<FormData>
}

export const FormRootError = <FormData extends Record<string, any>>({
  form: {
    formState: { errors },
    getValues,
  },
  ...otherProps
}: TFormRootErrorProps<FormData>): JSX.Element =>
  errors.root && !Object.keys(getValues()).some((key) => errors[key]) ? (
    <FormError {...otherProps}>{errors.root.message}</FormError>
  ) : null
